import { t as tr } from "../../../i18n";
import { fmt, type CaseId, type WallResult } from "@tasduvar/engine";
import { toSvg, type Transform } from "../geometry";

export function BasePressure({ t, result, caseId }: { t: Transform; result: WallResult; caseId: CaseId }): JSX.Element | null {
  const c = result.cases[caseId]; if (!c || !Number.isFinite(c.basePressure.qToe)) return null;
  const g = result.geometry, bp = c.basePressure;
  const qMax = Math.max(bp.qToe, bp.qHeel, 1e-9);
  const hpx = (q: number): number => (0.12 * g.yTop * t.scale * q) / qMax;
  // Diyagram tabanın 2 cm altından başlar; eğik tabanda taban doğrusunu izler (temas boyu taban boyunca → yatay izdüşüm ×cosα)
  const toe = toSvg(t, g.toe), heel = toSvg(t, g.heel);
  const s = g.baseSlope ?? 0, cos = 1 / Math.sqrt(1 + s * s);
  const baseAt = (x: number): { x: number; y: number } => toSvg(t, { x, y: g.toe.y - s * (x - g.toe.x) - 0.02 });
  const tri = bp.tensionRedistributed && bp.qHeel === 0;
  const p0 = baseAt(g.toe.x), p1 = tri ? baseAt(g.toe.x + bp.contactLength * cos) : baseAt(g.heel.x);
  const y0 = p0.y;
  const d = tri
    ? `M ${p0.x} ${p0.y} L ${p0.x} ${p0.y + hpx(bp.qToe)} L ${p1.x} ${p1.y} Z`
    : `M ${p0.x} ${p0.y} L ${p0.x} ${p0.y + hpx(bp.qToe)} L ${p1.x} ${p1.y + hpx(bp.qHeel)} L ${p1.x} ${p1.y} Z`;
  return (
    <g data-part="base-pressure">
      <path d={d} fill="#1F4E79" fillOpacity={0.15} stroke="#1F4E79" strokeWidth={1} />
      {/* Etiketler diyagramın iki yanında (altındaki ölçü zinciriyle çakışmasın); tarama üstünde okunsun diye beyaz kontur */}
      <text x={toe.x - 5} y={y0 + hpx(bp.qToe) / 2} textAnchor="end" dominantBaseline="middle" className="text-[10px] fill-accent num" paintOrder="stroke" stroke="#fff" strokeWidth={3}>{tr("q_burun =")} {fmt(bp.qToe, 1)} {tr("kN/m²")}</text>
      <text x={heel.x + 5} y={baseAt(g.heel.x).y + hpx(Math.max(bp.qHeel, bp.qToe / 2)) / 2} dominantBaseline="middle" className="text-[10px] fill-accent num" paintOrder="stroke" stroke="#fff" strokeWidth={3}>{bp.tensionRedistributed ? `temas ${fmt(bp.contactLength, 2)} m` : `q_topuk = ${fmt(bp.qHeel, 1)}`}</text>
    </g>
  );
}
